import { Link } from 'react-router-dom';
import { Instagram, Facebook, Phone, MapPin, Clock } from 'lucide-react';

const BANNER_URL = 'https://storage.googleapis.com/happyspace-preview-projects/uploads/projects/485ee0f5-162d-499f-b44f-69bc80fbabf9/1785626036737-vd8ge.png';

export default function Footer() {
  return (
    <footer className="bg-maroon text-[#F6E9D8] mt-auto" data-hs-id="footer">
      <div className="max-w-screen-xl mx-auto px-5 md:px-8 py-16 md:py-20 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-3 mb-4">
            <img src={BANNER_URL} alt="Biryani2Go — Dum-Cooked Biryani Takeout & Delivery" className="h-12 w-12 rounded-full object-cover ring-1 ring-white/20" />
            <span className="font-display text-xl tracking-tight text-[#F6E9D8]">Biryani2Go</span>
          </Link>
          <p className="text-sm leading-relaxed text-[#D9BFA6] max-w-[42ch]">
            Dum-cooked biryani, sealed and steamed to order. Every dabba is packed the way it's meant to travel —
            hot, fragrant, and ready to go.
          </p>
          <div className="flex gap-3 mt-6">
            <a href="#" aria-label="Instagram" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10 transition-colors">
              <Instagram size={18} />
            </a>
            <a href="#" aria-label="Facebook" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10 transition-colors">
              <Facebook size={18} />
            </a>
          </div>
        </div>

        <div>
          <h3 className="eyebrow text-marigold mb-4">Explore</h3>
          <ul className="space-y-3 text-sm text-[#D9BFA6]">
            <li><Link to="/menu" className="hover:text-white transition-colors">Full Menu</Link></li>
            <li><Link to="/about" className="hover:text-white transition-colors">Our Story</Link></li>
            <li><Link to="/gallery" className="hover:text-white transition-colors">Gallery</Link></li>
            <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Visit & Contact</Link></li>
            <li><Link to="/order-status" className="hover:text-white transition-colors">Track an Order</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="eyebrow text-marigold mb-4">Get in Touch</h3>
          <ul className="space-y-3 text-sm text-[#D9BFA6]">
            <li className="flex items-start gap-2">
              <MapPin size={16} className="mt-0.5 shrink-0" />
              <span>Location coming soon — <Link to="/contact" className="underline hover:text-white">contact us</Link></span>
            </li>
            <li className="flex items-start gap-2">
              <Phone size={16} className="mt-0.5 shrink-0" />
              <span>Phone coming soon</span>
            </li>
            <li className="flex items-start gap-2">
              <Clock size={16} className="mt-0.5 shrink-0" />
              <span>Hours coming soon</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 px-5 md:px-8">
        <p className="text-xs text-[#D9BFA6] max-w-screen-xl mx-auto">
          © {new Date().getFullYear()} Biryani2Go. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
